class ObstetricalCounters {
    public constructor(fields?: Partial<ObstetricalCounters>) {
        Object.assign(this, fields);
    }

    public Gravida: number;
    public Term: number;
    public Premature: number;
    public Abortion: number;
    public Live: number;
    public Stillbirth: number;
    // British Columbia specific counters.
    public AbortionInduced: number;
    public AbortionSpontaneous: number;
}

class ObstetricalSummary extends ObstetricalCounters {
    public constructor(fields?: Partial<ObstetricalSummary>) {
        super();
        Object.assign(this, fields);
    }

    public PatientContactFacetId: string;
    public IsPregnant: boolean;
    public CreatedBy: string;
    public CreationDate: Date;
    public LastUpdatedBy: string;
    public LastUpdateDate: Date;
}

export { ObstetricalCounters, ObstetricalSummary };
